var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlay(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.299V5.7c0 2.35 0 3.524.761 3.955.76.43 1.768-.173 3.782-1.382l1.17-.702C7.627 6.424 8.585 5.85 8.585 5c0-.85-.958-1.424-2.872-2.572l-1.17-.702C2.53.517 1.522-.087.761.344 0 .774 0 1.949 0 4.299z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSIxMCIgdmlld0JveD0iMCAwIDkgMTAiIGZpbGw9IndoaXRlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMCA0LjI5ODU3VjUuNzAxNDNDMCA4LjA1MDU5IDAgOS4yMjUxNyAwLjc2MDk1MiA5LjY1NjAxQzEuNTIxOSAxMC4wODY5IDIuNTI5MSA5LjQ4MjU0IDQuNTQzNDkgOC4yNzM5MUw1LjcxMjU0IDcuNTcyNDhDNy42MjcxOSA2LjQyMzY4IDguNTg0NTIgNS44NDkyOSA4LjU4NDUyIDVDOC41ODQ1MiA0LjE1MDcxIDcuNjI3MTkgMy41NzYzMiA1LjcxMjUzIDIuNDI3NTJMNC41NDM0OSAxLjcyNjA5QzIuNTI5MSAwLjUxNzQ1OSAxLjUyMTkgLTAuMDg2ODU3OSAwLjc2MDk1MiAwLjM0Mzk4NkMwIDAuNzc0ODI5IDAgMS45NDk0MSAwIDQuMjk4NTdaIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };